import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';

import { CONVERSATIONS } from '../utils/constants';

export default function useDeleteConversation() {
  const queryClient = useQueryClient();
  const { accountId, accountUserId } = useAdminParams();
  const { state } = useProvider();
  const args = state;

  return useMutation({
    mutationFn: async (id: string) => {
      const api = new Api(args);

      const data = await api.delete(
        await withAcl({
          account: {
            url: `api/v1/channels/toad/conversations/${id}`,
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/channels/toad/conversations/${id}`,
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CONVERSATIONS, { keyword: '' }],
      });

      toastSuccess('Successfully deleted conversation');
    },
  });
}
